import { Zap } from "lucide-react";
import { waLink, TRIAL_MSG } from "@/data/site";

export const AnnouncementBar = () => (
  <div
    className="relative border-b border-white/5 bg-wa/10"
    data-testid="announcement-bar"
  >
    <a
      href={waLink(TRIAL_MSG)}
      target="_blank"
      rel="noopener noreferrer"
      className="group mx-auto flex max-w-7xl items-center justify-center gap-2.5 px-4 py-2.5 text-center"
      data-testid="announcement-trial-cta"
    >
      <Zap className="h-3.5 w-3.5 shrink-0 text-wa" />
      <p className="whitespace-nowrap font-mono text-[10px] font-medium uppercase tracking-[0.18em] text-white/90 sm:text-[11px]">
        <span className="sm:hidden">Teste grátis de 12 horas</span>
        <span className="hidden sm:inline">
          Teste 100% gratuito de 12 horas — sem compromisso
        </span>
      </p>
      <span className="hidden whitespace-nowrap font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-wa transition-colors group-hover:text-neon sm:inline">
        Garantir agora →
      </span>
    </a>
  </div>
);
